"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NO_RESULT_FOUND = exports.API_SEARCH_RESULT_ERROR = void 0;
exports.API_SEARCH_RESULT_ERROR = 'There was an error when trying to retrieve your search results. Please try again later.';
exports.NO_RESULT_FOUND = 'There were no results found for your search.';
